/**
 * Copyright (c) 2022 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */

import * as React from 'react';
import { useEffect, useState } from 'react';
import { Box, Image } from 'grommet';

export namespace ImageViewer {
  export interface Props {
    alt: string;
    blob?: Blob;
  }
}

export const ImageViewer: React.FC<ImageViewer.Props> = ({ blob, alt }) => {
  const [url, setUrl] = useState<string>();
  useEffect(() => {
    if (!blob) {
      setUrl(undefined);
      return;
    }
    const reader = new FileReader();
    reader.onload = (event: ProgressEvent<FileReader>) => {
      setUrl(event.target?.result as string);
    };

    reader.readAsDataURL(blob);
  }, [blob]);

  if (!url) {
    return <></>;
  }

  return (
    <Box align="center" pad="medium">
      <Image alt={alt} src={url} />
    </Box>
  );
};
